import {
  NEEDS_INFO_CATEGORY_ORDER,
  type NeedsInfoCategory
} from "../../../constants/needs-info.ts"
import { type NeedsInfoItem } from "../../../types/lead.types.ts"

type NeedsInfoFormValue = Partial<
  Record<NeedsInfoCategory, { selected?: boolean; description?: string }>
>

const buildNeedsInfoItems = (raw?: NeedsInfoFormValue): NeedsInfoItem[] =>
  NEEDS_INFO_CATEGORY_ORDER.filter((category) => raw?.[category]?.selected).map(
    (category) => ({
      category,
      description: (raw?.[category]?.description ?? "").trim()
    })
  )

// Every category gets an explicit entry: antd registers each nested path as its
// own field, so a sparse object would leave an earlier session's values behind.
const needsInfoFormValueFrom = (
  items?: NeedsInfoItem[] | null
): NeedsInfoFormValue => {
  const byCategory = new Map(
    (items ?? []).map((item) => [item.category, item.description])
  )
  return NEEDS_INFO_CATEGORY_ORDER.reduce<NeedsInfoFormValue>(
    (acc, category) => {
      acc[category] = byCategory.has(category)
        ? { selected: true, description: byCategory.get(category) ?? "" }
        : { selected: false, description: "" }
      return acc
    },
    {}
  )
}

const sameNeedsInfoItems = (a: NeedsInfoItem[], b: NeedsInfoItem[]) =>
  a.length === b.length &&
  a.every(
    (item, index) =>
      item.category === b[index].category &&
      item.description === b[index].description
  )

export {
  buildNeedsInfoItems,
  needsInfoFormValueFrom,
  sameNeedsInfoItems,
  type NeedsInfoFormValue
}
